<template>
    <div class="user-dropdown">
        <div class="user-button">
            <span class="d-none d-sm-block">
                 
                <div v-if="user && user.name && compan">
                    {{ compan.nameCompany }} / {{ user.name }} <b-avatar button  size="sm"  variant="light" ></b-avatar>
                </div>
                <div v-else-if="user && user.name"> {{ user.name }} <b-avatar button  size="sm"  variant="light" ></b-avatar>  </div>
            </span>
            <i class="fa fa-angle-down ml-2"></i>
        </div>
        <div class="user-dropdown-content">
            <b-btn
                size="sm"
                v-b-modal.modalCompany
                @click.prevent="loadCompanys"
                title="Company"
                >Company</b-btn
            >
            <router-link to="/admin" v-if="user && user.admin">
                <i class="fa fa-cogs"></i> Administration
            </router-link>
            <router-link to="/changepassword">
                <i class="fa fa-key"></i> Change Password
            </router-link>
            <a href @click.prevent="logout">
                <i class="fa fa-sign-out"></i> Logout
            </a>
        </div>
        <b-modal
            id="modalCompany"
            ref="modal"
            title-tag="h6"
            title="Company"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="setCompany"
        >
            <b-form-select
                id="company-id"
                :options="companys"
                v-model="company.id"
            />
        </b-modal>
    </div>
</template>

<script>
import { userKey, companykey, searchglobalkey } from '@/global'
import { mapState } from 'vuex'
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'

export default {
    name: 'UserDropdown',
    data: function() {
        return {
            company: {},
            companys: [],
            usernew: {},
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark'
        }
    },
    components: {},
    computed: mapState(['user', 'compan']),
    methods: {
        logout() {
            localStorage.removeItem(userKey)
            localStorage.removeItem(companykey)
            localStorage.removeItem(searchglobalkey)
            this.$store.commit('setUser', null)
            this.$store.commit('setCompan', null)
            this.$store.commit('setSearchGlobal', null)
            this.$router.push({ name: 'auth' })
        },
        setCompany() {
            axios
                .post(`${baseApiUrl}/setCompany`, this.company)
                .then(res => {
                    localStorage.removeItem(companykey)
                    this.$store.commit('setCompan', res.data)
                    localStorage.setItem(companykey, JSON.stringify(res.data))
                    this.$router.push({ path: '/' })
                })
                .catch(showError)
        },
        loadCompanys() {
            const url = `${baseApiUrl}/companysuserscompanys/${this.user.id}`
            axios.get(url).then(res => {
                this.companys = res.data.map(company => {
                    return {
                        ...company,
                        value: company.id,
                        text: company.name_company
                    }
                })
            })
        }
    }
}
</script>

<style>
.user-dropdown {
    position: relative;
    height: 100%;
    font-size: 0.7rem;
}

.user-dropdown button,
popover {
    font-size: 0.7rem;
}

.user-dropdown select {
    font-size: 0.7rem;
}

.user-button {
    display: flex;
    align-items: center;
    color: #fff;
    font-weight: 100;
    height: 100%;
    padding: 0px 20px;
    font-size: 0.8rem;
}

#modalCompany select {
    font-size: 0.7rem;
}
#modalCompany button {
    font-size: 0.7rem;
}

.user-dropdown:hover {
    background-color: rgba(0, 0, 0, 0.2);
}

.user-dropdown-img {
    margin: 0px 10px;
}

.user-dropdown-img > img {
    max-height: 37px;
    border-radius: 5px;
}

.user-dropdown-content {
    position: absolute;
    right: 0px;
    background-color: #f9f9f9;
    min-width: 100px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    padding: 10px;
    z-index: 1;

    display: flex;
    flex-direction: column;
    flex-wrap: wrap;

    visibility: hidden;
    opacity: 0;
    transition: visibility 0s, opacity 0.5s linear;
}

.user-dropdown:hover .user-dropdown-content {
    visibility: visible;
    opacity: 1;
}

.user-dropdown-content a {
    text-decoration: none;
    font-weight: bold;
    color: #000;
    padding: 10px;
}

.user-dropdown-content a:hover {
    text-decoration: none;
    color: #000;
    background-color: #ededed;
}
</style>
